export const RoutePutStores_storeId_BindAll = "/stores/:storeId/bind-all";

export interface PayloadPutStores_storeId_BindAll {
  categories: number[];
}
